import Vue from 'vue'
import BootstrapVue from "bootstrap-vue"
import App from './App.vue'
import router from './router'
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap-vue/dist/bootstrap-vue.css"
import VueAffix from 'vue-affix'
import VueScrollactive from 'vue-scrollactive'
import VueScrollTo from 'vue-scrollto'

Vue.use(BootstrapVue)
Vue.use(VueAffix)
Vue.use(VueScrollactive)
Vue.use(VueScrollTo, {
  duration: 1000,
})

new Vue({
  el: '#app',
  router: router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js